export const MAX_MULTI_DAY_VISITS = 30;
